import VMenu from './VMenu'

export { VMenu }
export default VMenu



// WEBPACK FOOTER //
// ../../../src/components/VMenu/index.ts